// #618 (ADR-069) — the over-limit treasurer flag's one-click "cancel this donor's
// recurring gift". Given the over-limit contribution id, the server follows the
// series-link on the Contribution to the exact subscription and cancels just that
// one series (mirror → Canceled, reason limit-reached). No-ops cleanly for a
// one-time gift. The write set's RecurringDonation refreshes the recurring reads; the
// attention row reads the gift's series link, which a cancel leaves alone.

import type { CancelOverLimitRecurringRequest, CancelOverLimitRecurringResponse } from '@signalvote/shared';
import { apiJson } from './apiFetch';
import { defineWrite } from '../../lib/data';

export type { CancelOverLimitRecurringResponse };

/** Cancels the recurring series behind an over-limit contribution, given its `contributionId`. */
export const useCancelOverLimitRecurring = defineWrite({
  send: (contributionId: string) =>
    apiJson<CancelOverLimitRecurringResponse>('/api/finance/recurring/cancel-over-limit', {
      method: 'POST',
      json: { contributionId } satisfies CancelOverLimitRecurringRequest,
      error: 'Failed to cancel the recurring gift',
    }),
});
